/**
 * Definiert Basis-Model für die Auswertung der Aufgaben-Elementen
 * @class service_v3sExerciseElement
 * @memberOf v3sWbtPlayerApp:exercise
 */
angular.module('v3sWbtPlayerApp').factory('v3sExerciseElement', ["v3sExerciseElementStatus", "v3sExerciseService", function (v3sExerciseElementStatus, v3sExerciseService) {

   /**
   * Konstruktor
   * @memberOf v3sWbtPlayerApp:exercise.service_v3sExerciseElement
   */
    var v3sExerciseElement = function () {
        this.completed = false;
        this.feedbackVisible = true;

        this.showFeedback = function () { };

        this.STATUS = v3sExerciseElementStatus;
        this.status = this.STATUS.NO_ANSWER;
        this.answerAutoRemoved = false;
    };

    /**
   * Gibt zurück, ob Feedback sichtbar sein soll
   * @memberOf v3sWbtPlayerApp:exercise.service_v3sExerciseElement
   */
    v3sExerciseElement.prototype.isFeedbackVisible = function () {
        return this.feedbackVisible;
    };


    /**
   * Gibt den Aufgaben-Status zurück 
   * @memberOf v3sWbtPlayerApp:exercise.service_v3sExerciseElement
   * @return {@link v3sWbtPlayerApp:exercise.constant_v3sExerciseElementStatus} Statuswert 
   */
    v3sExerciseElement.prototype.getStatus = function () {
        return this.status;
    };

    /**
   * Gibt letztes Benutzer-Antwort zurück. <br>
   * @memberOf v3sWbtPlayerApp:exercise.service_v3sExerciseElement
   */
    v3sExerciseElement.prototype.getUserAnswer = function () {
        return this.userAnswer;
    };

    /**
   * Registriert das Element beim {@link v3sWbtPlayerApp:exercise.service_v3sExerciseService} und holt die letzte Auswertung
   * @memberOf v3sWbtPlayerApp:exercise.service_v3sExerciseElement
   * @return Auswertungsobjekt
   */
    v3sExerciseElement.prototype.load = function () {
        v3sExerciseService.addExercise(this);
        var evaluation = v3sExerciseService.getExerciseData(this);
        if (!!evaluation) {
            this.status = evaluation.status;
            this.userAnswer = evaluation.userAnswer;
        }
    };

    /**
   * Die Aufgabe wird von {@link v3sWbtPlayerApp:exercise.service_v3sExerciseService} geprüft und gespeichert
   * @memberOf v3sWbtPlayerApp:exercise.service_v3sExerciseElement
   * @return Auswertungsobjekt
   */
    v3sExerciseElement.prototype.save = function () {
        v3sExerciseService.updateExercise(this, { status: this.status, userAnswer: this.userAnswer });
    };

    /**
   * Gibt an, ob es eine korrekte Lösung für dieses Element existiert
   * @memberOf v3sWbtPlayerApp:exercise.service_v3sExerciseElement
   * @return {bool} korrekte Lösung existiert 
   */
    v3sExerciseElement.prototype.hasCorrectAnswer = function () {
        return true;
    };

    /**
      * Gibt an, ob falsche Anwort automatisch gelöscht wurde
      * @memberOf v3sWbtPlayerApp:exercise.service_v3sExerciseElement
      * @return {bool} falsche Anwort wurde automatisch gelöscht
      */
    v3sExerciseElement.prototype.isAnswerAutoRemoved = function () {
        return this.answerAutoRemoved;
    };

    /**
   * Schließt die Auswertung des Elements ab und zeigt den Feedback an
   * @memberOf v3sWbtPlayerApp:exercise.service_v3sExerciseElement 
   */
    v3sExerciseElement.prototype.complete = function (feedbackVisible) {
        this.completed = true;
        this.feedbackVisible = feedbackVisible;
        this.showFeedback();
    };
    
    /**
   * Legt die Feedback-Darstellung fest
   * @param {function} showFeedback - Funktion für die Feedback-Darstellung
   * @memberOf v3sWbtPlayerApp:exercise.service_v3sExerciseElement 
   */
    v3sExerciseElement.prototype.setShowFeedback = function (showFeedback) {
        this.showFeedback = showFeedback;

        if (this.completed) {
            this.showFeedback();
        }
    };

    return v3sExerciseElement;
}]);